import { z } from 'zod';
import { Attributes } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.imagine.forms.validators.RequiredValidator');
export default {
  createFor(name, objectType, {
    molten
  }) {
    const attr = Attributes.getAttribute(name, objectType);
    molten.addPlugin('AttributeValueValidator', {
      name,
      objectType,
      labelDecorator: value => {
        return `${value} *`;
      },
      valueValidator: z.custom(val => {
        if (val == null) {
          return false;
        }
        if (typeof val === 'string' && val.trim().length === 0) {
          return false;
        }
        return true;
      }, {
        message: t('message', {
          name: attr.displayName || 'Field'
        })
      })
    });
  }
};